import { render, staticRenderFns } from "./cert-center-work.vue?vue&type=template&id=073fa732&scoped=true&"
import script from "./cert-center-work.vue?vue&type=script&lang=js&"
export * from "./cert-center-work.vue?vue&type=script&lang=js&"
import style0 from "./cert-center-work.vue?vue&type=style&index=0&id=073fa732&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073fa732",
  null
  
)

export default component.exports